module.exports = {
  app: {
    refreshSuccess: "Refresh successed",
    logoutMSG:
      "Are you sure want to log out your Single Sign On (SSO) identity? All systems that are using SSO will be logged out.",
    appName: "UTM HMS",
    login: "Login",
    fronDeskLogin: "Front desk login",
    en: "English",
    zhTW: "Chinese traditional",
    backgroundSystemLogin: "Background system login",
    applicationNumber: "Application No",
    certificateNumber: "ID No",
    logout: "Logout",
    personalInfo: "Personal Data",
    statement: "Declaration",
    gender: "Gender",
    male: "Male",
    female: "Female",
    surname: "Last name",
    firstName: "First name",
    chineseName: "Name in Chinese",
    countryDialCode: "Country calling code",
    mobilePhoneNumber: "Mobile number",
    emailAddress: "Contact email",
    applicationForAccommodation: "Hostel Application",
    noSpecialPreference: "No particular preference",
    studentsFromTheirCountryOrRegion: "Student from same country or region",
    internationalStudentsFromOtherRegions:
      "International student from other countries",
    exchangeStudentsFromOtherInstitutions:
      "Exchange student from another university",
    arriveInMacau: "Arrival Information",
    //arriveInMacauCheckInDesc: "The earliest check-in date for the hostel is 15 August.  Check-in earlier than the arrival date specified is not allowed.",
    arriveInMacauCheckInDesc: "Hostel will be opened for check-in starting from the first day of registration (announced by the Pedagogic Affairs Department). Early check-in prior to that date could not be arranged.",
    arriveInMacauCheckInDesc2: "The total hostel fee will be calculated based on your specified arrival date.  Standard accommodation fee for the first semester is from 16 August 16 to 31 December. Early check-in will be charged either half-monthly or according to the daily rate approved by the Administrative Council for outside guests (whichever is lower).",
    dateOfArrivalInMacao: "Arrival date",
    timeOfArrivalInMacao: "Expected arrival time",
    portOfArrival: "Arrival port",
    submit: "Submit",
    reset: "Reset",
    name: "Name",
    studentNumber: "Student No.",
    contactNumber: "Contact No.",
    roomNumber: "Room No.",
    declarationItems: "Declaration Issues",
    sleepOutDestination: "Sleep Out Destination",
    DateofReturnLateOrSleepOut: "Date of Return Late or Sleep Out",
    ExceptionStatus: "Non-Conformity Situation",
    currentRoomNumber: "Current room number",
    yes: "Yes",
    no: "No",
    changeRoommates: "Change roommates",
    changeRoomType: "Change the room type",
    changeRoomNumber: "Change room number",
    otherNeeds: "Any Other Request?",
    checkOutDate:
      "Check Out Date(UTM will issue debit note according to the check out date selected for extended stay)",
    // planCheckOutDate: "Check out date for this semester",
    planCheckOutDate:
      "Check Out Date(UTM will issue debit note according to the check out date selected for extended stay)",
    guestRoom: "Guest Room",
    suite: "Suite",
    exchangeStudentsFromTheirInstitutions:
      "Exchange student from own university, if any",
    systemManagement: "System Management",
    roleManagement: "Role Management",
    roleCoding: "Role coding",
    roleName: "Role name",
    operation: "Operation",
    enable: "Enable",
    bindingPermissions: "Menu Permission",
    operationPermission: "Operation Permission",
    edit: "Edit",
    new: "New",
    userManagement: "User Management",
    confirmModification: "Confirm modification",
    refuseModification: "Confirm to refuse the application",
    tips: "Tips",
    confirm: "Confirm",
    cancel: "Cancel",
    confirmAdd: "Confirm Add",
    delete: "Delete",
    bindRole: "Bind role",
    username: "Username",
    isDelete: "Are you sure to delete?",
    pleaseEnterKeywordSearch: "Please enter keyword search",
    dictionaryManagement: "Dictionary management",
    opeSuccess: "The operation was successful",
    success: "Success",
    account: "Account",
    studentLogin: "Login ID",
    dicCode: "Dictionary item type code",
    dicName: "Dictionary item type name",
    description: "Description",
    isUse: "Enable",
    disable: "Disable",
    serialNumber: "Serial number",
    dicItem: "Dictionary item",
    dicItemManagement: "Dictionary item management",
    dicItemCode: "Dictionary item code",
    dicItemName: "Dictionary item name",
    templateManagement: "Template management",
    templateCode: "Template code",
    templateName: "Template name",
    addressee: "addressee",
    CC: "CC",
    bcc: "bcc",
    theme: "Theme",
    content: "Content",
    roomManagement: "Room management",
    floorName: "Floor name",
    floorCode: "Floor code",
    roomCode: "Room No",
    roomType: "Room type",
    roomStatus: "Room status",
    roomRemark: "Remark",
    macroInsert: "Macro insert",
    dormitoryList: "Dormitory list",
    dormitoryManagement: "Dormitory management",
    mandatoryCheckOutDate: "Mandatory check out date",
    room: "Room",
    bed: "Bedspace",
    nameEnglish: "Name in English",
    nameChina: "Name in Chinese",
    contactInformation: "Contact No",
    adjustment: "Adjustment",
    checkOut: "Check out",
    adjustmentApplication: "Adjustment application",
    remarks: "remarks",
    applicationRequirements: "Application requirements",
    mandatoryCheckOutDateSetting: "Mandatory check out date setting",
    checkOutDateOfTheFirstSemester: "Check out date of the first semester",
    checkOutDateOfTheSecondSemester: "Check out date of the second semester",
    resourceManagement: "Resource management",
    menuName: "Menu name",
    menuCode: "Menu code",
    parentMenuName: "Parent menu name",
    preDistributionOfNewStudents: "Pre distribution of new students",
    preDistributionOfOldStudents: "Pre distribution of old students",
    search: "Search",
    batchConfirmation: "Batch confirmation",
    status: "Debit Status",
    feePaid: "Fee paid",
    unpaidFee: "Unpaid fee",
    confirmS: "Confirm",
    parameterConfiguration: "Parameter configuration",
    accommodationParameterConfiguration:
      "Accommodation parameter configuration",
    mailParameterConfiguration: "Mail parameter configuration",
    oldStuStartDate: "Application start date of old students",
    newStuStartDate: "Application start date of new students",
    oldStuEndDate: "Application end date of old students",
    newStuEndDate: "Application end date of new students",
    isSubmit: "Are you sure to submit?",
    mailServe: "Mail serve",
    mailSender: "Mail sender",
    mailAddress: "Mail address",
    noStuFound: "No students found",
    startPreAlloc: "Start preallocation",
    bedCode: "Bed No.",
    bedStatus: "Bed status",
    viewDetails: "View details",
    details: "Details",
    dormitoryDiagram: "Dormitory diagram",
    selectAll: "Select all",
    password: "Password",
    pickUpServiceDate: "Pick up service date",
    exchange: "Exchange",
    floor: "Floor",
    overnight: "Return at night",
    financialManagement: "Financial management",
    hotelExpense: "Hotel expense",
    returnInNight: "Return in night",
    hostelCheckoutReservation: "Hostel Check out Reservation",
    studentIDNo: "Student ID No",
    contactNo: "Contact No",
    residentialInformation: "Residential Information",
    hostelRoomNo: "Hostel Room No",
    expectedCheckoutDate: "Expected Check out Date",
    reasonForLateCheckout: "Reason for Late Check out",
    uploadSupportingDocument: "Upload Supporting Document",
    expectedCheckoutTime: "Expected Check out Time",
    checkInResult: "Accommodation application results",
    Announcement: "Announcement of accommodation application results",
    pickUpServiceTime: "Pick up service time",
    checkOutTime: "Scheduled check-out time",
    checkOutApproval: "Check out approval",
    reportCenter: "Report center",
    checkIn: "Check in",
    pickup: "Pick up schedule",
    checkOutStartTime: "Check out start time",
    checkOutEndTime: "Check out end time",
    isCheckIn: "Has check in",
    isNotCheckout: "Not checkout when expired",
    confirmDebit: "Are you sure to debit?",
    changeDateBegin: "Change date from",
    changeDateEnd: "Change date to",
    currentRoom: "Current Room",
    checkoutDate: "Booking/Coercive check out date",
    startSearchDate: "Start Date",
    endSearchDate: "End Date",
    studentNative: "Native",
    studentProgramme: "Programme",
    specialRequirement: "Special requirement",
    to: "to",
    invertSelect: "Invert",
    studentType: "Admission Type",
    ascOrder: "Asc",
    descOrder: "Desc",
    hasConfirm: "Has confirm",
    hasCheckout: "Has checkout",
    isApplyHostel: "Has apply hostel",
    applyDate: "Apply Date",
    isStayover: "Is Stay Over",
    isKeepRoom: "Is Keep Room",
    checkOutSearchStartTime: "Start time",
    checkOutSearchEndTime: "End time",
    applicationDescription:
      "It is out of the hostel application period currently, please find your application record as follows.",
    tooltip:
      "For optimal viewing of the content, use browsers on your computer is recommended",
    roomIndexNotEAHstartWith:
      "The room number does not comply with the rules, such as not being prefixed with EAH-",
    batchCheckIn: "batchCheckIn",
    batchCheckOut: "batchCheckOut",
    batchSetBedTags: "batchSetBedTags",
    bedTages: "bed tags",
    validation: {
      complete: "Please complete the information",
      declare: "Please read the statement first",
      applyCode: "Please enter the application number",
      gender: "Please select gender",
      surname: "Please enter your last name",
      name: "Please enter your name",
      countryCode: "Please enter the country dial code",
      tel: "Please enter your mobile phone number",
      email: "Please enter your email",
      category: "Please choose the room type",
      roommate: "Please choose a roommate",
      serve: "Please select service",
      direction: "Please choose the port of arrival",
      date: "Please select the date",
      time: "Please select the time",
      studentNumber: "Please enter student number",
      reason: "Please enter destination",
      roomNumber: "Please enter room number",
      phone: "Please input the contact number",
      select: "Please select",
      currentRoomNumber: "Please input the current housing number",
      isKeepFalse: "Do not apply for accommodation is not optional",
      room: "Please enter Hostel Room No",
      destination: "Please enter destination"
    },
    router: {
      home: "Home",
      homeB: "Home",
      newStu: "Home",
      oldStu: "Home",
      applicationForAccommodation: "Hostel Application",
      applicationForAccommodationOld: "Hostel Application",
      nightReturnRegistration: "Return Late or Sleep Out Declaration Form",
      nightReturnParent: "遲歸或外宿",
      systemManagement: "System Management",
      roleManagement: "Role Management",
      userManagement: "User Management",
      dictionaryManagement: "Dictionary management",
      templateManagement: "Template management",
      roomManagement: "Room management",
      dormitoryList: "Dormitory list",
      dormitoryManagement: "Dormitory management",
      resourceManagement: "Resource management",
      preDistributionOfNewStudents: "Pre distribution of new students",
      preDistributionOfOldStudents: "Pre distribution of old students",
      parameterConfiguration: "Parameter configuration",
      dormitoryDiagram: "Dormitory diagram",
      overnight: "Return at night",
      financialManagement: "Financial management",
      hotelExpense: "Hotel expense",
      returnInNight: "Return Late or Sleep Out Record",
      hostelCheckoutReservation: "Hostel Check out Reservation",
      checkInResult: "Accommodation application results",
      checkOutApproval: "Check out approval",
      reportCenter: "Report center",
      checkIn: "Check in",
      guest: "Guest hostel",
      pickup: "Pick up schedule",
      documentManagement: "Document management",
      documentStudent: "Student's document",
      guestAppointment: "Booking",
      guestAppointmentList: "Booking list",
      checkOut: "Checkout Report",
      arrival: "Arrival Report",
      bedChange: "Bedspace Change Report",
      bed: "Room/Bed Status Report",
      departure: "Departure Report",
      payment: "Payment Report",
      guestReport: "Outside Guest Report",
      cashierReport: "Cashier Report",
      cashier: "Cashier Report",
      hostelApplyList: "Hostel Application List",
      hostelCheckoutHistory: "Checkout History",
      logViewer: "Operation Log",
      studentApplicationHistory: "Student Application Record",
      defaultFee: "Fee",
      BedTagsManagement: "bed tags management",
      bedtagBalance: "BedtagBalance Report"
    },
    loginView: {
      newStudent: "New Student",
      oldStudent: "Current Student"
    },
    applyView: {
      leaveTime: "Departure time from origin",
      flightNumber: "Flight number",
      leaveDate: "Date of departure from origin",
      departurePort: "Departure port (airport name & city or country)",
      statementMSG:
        "I declare I have already read all hostel related information as shown on the website",
      name: "Name",
      originalInstitution:
        "Home institution and country (for exchange students only)",
      roomChoose:
        "Preferred Room Type (Hostel fees are payable on a semester basis, the amount of hostel fees calculated per semester are based on the academic calendar)",
      single: "Single Room (Subject to availability)",
      double: "Twin sharing Room",
      roommate: "Preferred roommate (same gender only)",
      other: "Please specify below if special arrangement is needed:",
      declareCost:
        "I hereby acknowledge that the hostel fee does not cover electricity consumption in the bedroom; electricity fee is to be shared among occupants in the same room on a monthly basis",
      serve: "Arrival pick-up request",
      serveI:
        "Upon arrival in Macao, I will go to the East Asia Hall on my own.",
      serveII:
        "I would appreciate to have pick-up service upon arrival in Macao.",
      pathI: "By air at Macau International Airport",
      pathII:
        "By land at Macau Barrier Gate (Please pass through both the GongBei Port and the Macau Barrier Checkpoint)",
      pathIII:
        "By sea at Macau Outer Harbour Ferry Terminal (also known as Macau Maritime Ferry Terminal)",
      pathIV: "By sea at Macau Taipa Temporary Ferry Terminal",
      pathV: "By sea at Macau Interior Port Ferry Terminal",
      declareFinal:
        " I hereby declare that the above accommodation request is my final decision. I agree to comply with the Hostel Rules and Regulations throughout the period of stay. Due to limited availability, room preferences at the Student Hostel have to be allocated on a first-come-first-served basis, per application sequence. It is not guaranteed that rooms must be assigned according to students' preferences."
    },
    checkoutView: {
      statement:
        "I hereby declare that I am notified that all personal belongings are not allowed to store or keep in my present room after my check-out from the hostels. The Hostel Management Team 丨s authorized to dispose the unclaimed items 丨n any manner considered suitable.",
      remarksA:
        "1.Hostel Student must submit online Hostel Check out Form at least 3 days prior to the planned check out date OR by 28 December (1st semester) OR by 28 May (2nd semester)",
      remarksB:
        "2.Students are responsible to clear all the personal belongings and clean the room thoroughly; all furniture in the room must be restored to the original setting",
      remarksC:
        "3.During check out, warden will check the hostel room and arrange for luggage storage which will take around 15-20 minutes, please pack all belongings in advance and leave enough time for the procedure.",
      remarksD:
        "4.Students who have successfully re-apply for hostel placement are allowed to store up to three pieces of luggage. Unclaimed luggage will be disposed. UTM is not liable for any loss or damage of the stored luggage or items in the luggage."
    },
    overnightView: {
      factor: "Choose one of the following answers",
      factorI:
        "Returning home on Fri to Sun and holidays as home is located near Macau",
      factorII: "Apply for staying outside with reasons other than going home",
      factorIII: "Return to Hostel later between 12 midnight to 3 a.m.",
      date: "Date of Return Late or Sleep Out",
      reason: "Reason for Return Late or Sleep Out",
      declare:
        "I hereby declare that the information provided is true and correct.",
      isLeave: "Destination (Please specify the region)"
    },
    template: {
      name_address_un: "Items unrelated to name and address",
      sender: "Items related to the sender",
      recipients: "Items related to the recipients",
      topic: "Items related to the recipients",
      cursor: "Editor cursor position",
      quotes: "Refer to the content of the original email",
      text: "Original email content",
      date: "Current date",
      time: "Current time",
      oDate: "Date of letter",
      oTime: "Time of letter",
      oSubject: "Subject of letter",
      attachList: "List of attachments",
      onoContent: "Do not use or reference metamessage content",
      fromName: "Sender's name",
      replyName: "Reply name",
      fromAddr: "Sender email address",
      replyAddr: "Reply address",
      oFromName: "The sender name of the original message",
      oReplyName: "Reply name of original message",
      oFromAddr: "The email address of the sender of the original message",
      oReplyAddr: "Reply address of original mail",
      toName: "Recipient's name",
      toAddr: "Recipient email address",
      oToName: "The name of the recipient of the original message",
      oToAddr: "The recipient address of the original message",
      OccName: "CC name of original mail",
      OccAddr: "CC address of original mail",
      sDate: "System current date",
      sTime: "System current time"
    },
    applyOldView: {
      isContinue:
        "Do you want to apply for accommodation for the next semester",
      noI:
        "No, I will withdraw from UTM Hostel due to overseas internship/exchange.",
      noII:
        "No, I will withdraw from UTM Hostel and arrangement accommodation on my own(Hostel placement will not be guaranteed after withdrawal).",
      noIII: "No, I will withdraw from UTM hostel due to graduation.",
      isKeep: "Would you like to maintain the current room allocation? (Options selected are not guaranteed)",
      specialTypeDetail: "Scholarship Recipient"
    },
    // 新增房型選擇 laotang 2023-04-12
    roomTypeSelect: {
      title:
        "Preferred Room Type (Due to the limited availability for certain room types, if the selected room type is not available, room allocation will be decided by random drawing.)",
      noI: "Single Room（1/F-17/F）",
      noII: "Twin-sharing Room（1/F-17/F）",
      noIII:
        "Garden View Twin-sharing Room（18/F-21/F newly renovated floors）",
      noIIII: "Sea View Twin-sharing Room（18/F-21/F newly renovated floors）",
      noIIIII: "Triple Room（1/F-17/F）",
      noIIIIII: "Quad Room（1/F-17/F）",
      remark1:
        "Note: Due to limited availability, Year 1 undergraduate students are first considered, therefore renewal of tenancy in the following years cannot be guaranteed. Postgraduate student application is not guaranteed and will be put on the waiting list, the results will be announced via email around early August. Room will be arranged according to first come first served basis, if your requested room type is not available, the next best alternative room type will be arranged, please refer to the hostel website for the hostel fee."
    },
    schoolYear: "SchoolYear",
    semester: "Semester",
    bedTags: {
      code: "Bed tag code",
      name: "Bed tag name",
      enable: "Enable",
      schoolYear: "School year",
      description: "Notes",
      confirmModification: "Confirm to copy the selected school year tag data?"
    }
  }
};
